import type { RadioGroupProps as MuiRadioGroupProps } from "@mui/material/RadioGroup";
import MuiRadioGroup from "@mui/material/RadioGroup";
import { Typography } from "../../General";
import { FormControl, FormHelperText } from "../_partials";
import styles from "./RadioGroup.module.scss";
import { RadioItem } from "./RadioItem";
import { RadioOption } from "./types";

export interface RadioGroupProps<OptionType extends RadioOption>
    extends Pick<MuiRadioGroupProps, "defaultValue" | "onChange" | "row" | "value"> {
    helperText?: string;
    inputRef?: React.Ref<HTMLInputElement>;
    isError?: boolean;
    label: string;
    name: string;
    options: OptionType[];
    renderOption?: (option: OptionType, isSelected: boolean) => React.ReactNode;
}

export function RadioGroup<OptionType extends RadioOption>({
    defaultValue,
    helperText = "",
    inputRef,
    isError = false,
    label,
    name,
    onChange,
    options,
    renderOption,
    row = false,
    value,
}: RadioGroupProps<OptionType>) {
    return (
        <FormControl component="fieldset" isError={isError}>
            <Typography className={styles["legend"]} component="legend" variant="label">
                {label}
            </Typography>
            <MuiRadioGroup
                defaultValue={
                    defaultValue || options.find((option) => option.disabled !== true)?.value
                }
                name={name}
                onChange={onChange}
                row={row}
                sx={{ columnGap: row && renderOption === undefined ? 1 : 0 }}
                value={value}
            >
                {options.map((option) => (
                    <RadioItem
                        description={option.description}
                        disabled={option.disabled}
                        inputRef={inputRef}
                        key={option.value}
                        label={option.label}
                        renderOption={renderOption}
                        selectedValue={value}
                        value={option.value}
                    />
                ))}
            </MuiRadioGroup>
            {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
        </FormControl>
    );
}
